import i18n from "@/i18n";
import {
  APP_LOCALE_KEY,
  readPersistedLocale,
  getInitialAppLocale,
  localeFromVkorg,
} from "@/utils/appLocaleConstants";

export { APP_LOCALE_KEY, readPersistedLocale, getInitialAppLocale, localeFromVkorg };

/** Rutas invitado donde aplica la regla “guardado o español” (misma que login). */
const GUEST_LOCALE_PATHS = ["/login", "/remember-password", "/new-password", "/review-password"];

export function shouldApplyGuestLocale(path) {
  return GUEST_LOCALE_PATHS.includes(path);
}

/** Login / flujos invitado: `app_locale` válido o español. */
export function applyLoginScreenLocale() {
  const next = getInitialAppLocale();
  if (i18n.global.locale.value !== next) i18n.global.locale.value = next;
}

/**
 * Tras PostLogin: respeta siempre `app_locale` si existe; si no, VKORG y persiste.
 * @param {string | number | null | undefined} vkorg
 */
export function syncLocaleAfterLogin(vkorg) {
  const stored = readPersistedLocale();
  const next = stored || localeFromVkorg(vkorg);
  i18n.global.locale.value = next;
  if (!stored) localStorage.setItem(APP_LOCALE_KEY, next);
}
